import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';

import UiContext from 'common/UiContext/UiContext';
import modalsIndex from './modalsIndex';

import Icons from 'assets/images/Icons';

import './modals.scss';
import useClickOutside from 'common/useClickOutside';

const Modal = () => {
  const { modal, closeModal } = useContext(UiContext);
  const [{ Component, title }, setCurrentModal] = useState(modalsIndex['OtpChallenge']);

  const clickOutsideRef = useClickOutside(closeModal!);

  useEffect(() => {
    if (modal) {
      setCurrentModal(modalsIndex[modal]);
    }
  }, [modal]);

  return (
    <div className={classNames({ modal: true, open: null !== modal })}>
      <div className='modal-container' ref={clickOutsideRef}>
        <div className='title'>
          <h3>{title}</h3>
          <button onClick={closeModal}><Icons name='Cancel' /></button>
        </div>
        <Component close={closeModal!} />
      </div>
    </div>
  );
};

export default Modal;